<template lang="pug">
  .user-settings
    .user-settings__title
      h1.title Настройки аккаунта
    .user-settings__main
      .profile-page-form
        section.profile-page-form__section.profile-section
          .profile-section__title
            h2.profile-section-title Пароль
          .profile-section__body
            form-password
</template>

<script>
import FormPassword from "../../../../components/form-password/form-password";
export default {
  name: "operator-settings",
  components: { FormPassword },
};
</script>
